import styled from "@emotion/styled";
import { Box, IconButton, keyframes } from "@mui/material";
import useFavorites from "components/Favorites/useFavorites";
import { IconBadge } from "components/Icons";
import LanguageMenu from "components/LanguageMenu/LanguageMenu";
import PropTypes from "prop-types";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";
import { toggle_drawer } from "state/actions";
import { useAtom, useGet } from "state/jotai";
import { useBreak }       from 'hooks/useBreak'
import { useLocation }    from 'react-router-dom'
import { _project } from "state/store.projects";
import { active_project, current_language, params_query, previousUrl, vis_desktop_nav  }       from "state/store.global";
import { NavMapModal } from "components/Unit/NavMapModal";
import { MapModalButton } from "components/Unit/FullscreenMap";
import useCompares from "hooks/useCompares";
import { isIframeMode } from "logging/logging";

const swing = keyframes`
  20% { transform: rotate3d(0, 0, 1, 15deg); }
  40% { transform: rotate3d(0, 0, 1, -10deg); }
  60% { transform: rotate3d(0, 0, 1, 5deg); }
  80% { transform: rotate3d(0, 0, 1, -5deg); }
  to { transform: rotate3d(0, 0, 1, 0deg); }
`;

const SwingAnimation = styled.div(({ isAnimated }) => ({
  display: "inline-flex",
  transformOrigin: "top center",
  animationName: isAnimated ? swing : "none",
  animationDuration: "1s",
  animationIterationCount: "infinite",
}));

function NavItems({ hideNav }) {
 const { pin, pid } = useGet(active_project)
  const isDesktop    = useBreak('md_up')
  const here         = useLocation().pathname
  const atUnit       = here.includes('unit')

  return (
    <Box sx={{ display: "flex", ml: "auto", pr:!isDesktop  ? 1 :0, "& > .MuiIconButton-root, & > div > .MuiIconButton-root": { fontSize: 28, }, "& > div": { display: "flex", }, "& > .MuiIconButton-root, & > div": {paddingRight : "16px" , paddingY:"12px" }, "& > :last-child": { paddingRight: isDesktop ? 0 : "16px"}, }} style={{position: !isDesktop  ? "relative" : " ", top: "0"}}>
    {(!atUnit || isDesktop) && <NavCompares sx={{ visibility: hideNav ? "hidden" : "visible", }} />}
    {(!atUnit || isDesktop) && <NavFavorites sx={{ visibility: hideNav ? "hidden" : "visible", }} />}
   {  !atUnit &&  <NavMapModal />}
    <MapModalButton />
    {/* <LanguageMenu sx={{paddingLeft:"8px"}}/> */}
   
  </Box>
  );
}

NavItems.propTypes = { hideNav: PropTypes.bool, };

const Swing = forwardRef(({ children }, ref) => {

  const [isAnimated, setIsAnimated] = useState(false);
  const trigger = () => { setIsAnimated(true); };

  useEffect(() => {
    if (isAnimated) {
      const timeout = setTimeout(() => { setIsAnimated(false); }, 1000);
      return () => { clearTimeout(timeout); };
    }
  }, [isAnimated]);

  useImperativeHandle(ref, () => ({ trigger, }));

  return <SwingAnimation isAnimated={isAnimated}>{children}</SwingAnimation>;
});

Swing.displayName = "Swing";
Swing.propTypes = { children: PropTypes.node, };

const NavFavorites = (props) => {
     const iFrameEnabled = isIframeMode()
      const here                              = useLocation().pathname;
       const isIsometry                        = here.includes("isometry")
  const { count }                  = useFavorites();
  const swingRef                   = useRef(null);
  const navigateTo                 = useNavigate();
  const params                     = useGet(params_query)
  const toggleDrawer               = useAtom(toggle_drawer)[1];
  const language = useAtom(current_language)[0];
  const [show, setShow]            = useAtom(vis_desktop_nav);
  const handleClick                = () => { navigateTo(`${language}/favorites${params.length ? params : ''}`); toggleDrawer(); setShow(false);};  useEffect(() => { if (swingRef.current) { swingRef.current.trigger(); } }, [count]);
  if (0 === count) { return <></>; }
  return (
  
    <IconButton disableRipple
    disableFocusRipple  {...props} onClick={handleClick}>
      <Swing ref={swingRef } >
        <span className="icon-hover-effect" style={{paddingTop:"4px"}}>
        <IconBadge style={{color: iFrameEnabled ? (isIsometry ? clr?.primary_text : "#000") : clr?.primary_text}} icon="heart_empty"  badge={count} size="sm" />
        </span>
      </Swing>
    </IconButton>
  
  );
};

const NavCompares = (props) => {
  const location = useLocation();
    const here                              = useLocation().pathname;
     const isIsometry                        = here.includes("isometry")
  const [, setPreviousUrl] = useAtom(previousUrl);
  const iFrameEnabled = isIframeMode()
  const { count } = useCompares();
  const swingRef = useRef(null);
  const navigateTo = useNavigate();
  const params           = useGet(params_query)
  const toggleDrawer = useAtom(toggle_drawer)[1];
  const language = useAtom(current_language)[0];
  const [show, setShow] = useAtom(vis_desktop_nav);
  const handleClick = () => { navigateTo(`${language}/compare${params.length ? params : ''}`); toggleDrawer(); setShow(false); if(!location.pathname.includes("compare")) setPreviousUrl(location.pathname)}; 
  useEffect(() => { if (swingRef.current) { swingRef.current.trigger(); } }, [count]);
  if (0 === count) { return <></>; }
  return (
 
    <IconButton disableRipple
    disableFocusRipple  {...props} onClick={handleClick}>
      <Swing ref={swingRef}>
      <span className="icon-hover-effect" style={{paddingTop:"4px"}}>
        <IconBadge style={{color: iFrameEnabled ? (isIsometry ? clr?.primary_text : "#000") : clr?.primary_text}}  icon="compare" badge={count} size="sm" />
        </span>
      </Swing>
    </IconButton>
   
  );
};

export default NavItems;
